module.exports = __webpack_public_path__ + "img/edit-primary.fe2be454.svg";